// These filters are used by the API to fetch status groups for the dashboard view.
export const FILTERS = Object.freeze({
  ACTIVE: 'active',
  INACTIVE: 'inactive',
});
